import React from 'react';
import { Award, Shield, CheckCircle, Phone } from 'lucide-react';
import { whyChooseUs } from '../data/mock';

const iconMap = {
  award: Award,
  shield: Shield,
  'check-circle': CheckCircle,
  phone: Phone
};

const About = () => {
  return (
    <section id="about" className="py-20 bg-gradient-to-b from-white to-slate-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-block px-4 py-2 bg-orange-100 rounded-full mb-4">
              <span className="text-orange-700 font-semibold text-sm">Why Choose Us</span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
              Your Trusted Pool & Spa Partner in{' '}
              <span className="bg-gradient-to-r from-cyan-600 to-blue-600 bg-clip-text text-transparent">
                Texas
              </span>
            </h2>
            
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              At Waterlife Pools & Spas, we're more than just a service provider – we're your partners 
              in creating and maintaining the perfect outdoor oasis. With over two decades of experience 
              and thousands of satisfied customers across Texas, we deliver unmatched quality and reliability.
            </p>

            <div className="space-y-6">
              {whyChooseUs.map((item, index) => {
                const Icon = iconMap[item.icon];
                return (
                  <div 
                    key={item.id}
                    className="flex items-start space-x-4 group"
                  >
                    <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-cyan-400 to-blue-600 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-md">
                      <Icon className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-slate-900 mb-1 group-hover:text-cyan-600 transition-colors duration-200">
                        {item.title}
                      </h3>
                      <p className="text-slate-600">{item.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right Image Grid */}
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-4">
              <div className="relative overflow-hidden rounded-2xl shadow-xl group">
                <img 
                  src="https://lonestarcomponents.com/wp-content/uploads/2025/07/Malibu-Fiji-Blue-pool-6.jpg"
                  alt="Malibu Fiji Blue Pool"
                  className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
              <div className="relative overflow-hidden rounded-2xl shadow-xl group">
                <img 
                  src="https://lonestarcomponents.com/wp-content/uploads/2025/07/Laguna-Fiji-Blue-pool-4.jpg"
                  alt="Laguna Fiji Blue Pool"
                  className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
            </div>
            <div className="space-y-4 pt-8">
              <div className="relative overflow-hidden rounded-2xl shadow-xl group">
                <img 
                  src="https://lonestarcomponents.com/wp-content/uploads/2025/07/Cabo-serenity-tanning-ledge-Fiji-Blue.jpg"
                  alt="Cabo with Spa & Tanning Ledge"
                  className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
              <div className="relative overflow-hidden rounded-2xl shadow-xl group">
                <img 
                  src="https://lonestarcomponents.com/wp-content/uploads/2025/07/Independence-Caribbean-Blue-pool-4.jpg"
                  alt="Independence Caribbean Blue Pool"
                  className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
